"use strict";

import angular from "angular";

import template from "./admin-layout.component.html";
import "./themes/admin-layout.component.scss";

import _ from "lodash";
import { EadPlataformaService } from "../../../../gateway/EadPlataformaService/EadPlataformaService";
import { Insight } from "../../../../gateway/Insight/Insight";
import { OperationStatus } from "../../../../gateway/OperationStatus/OperationStatus";
import { User } from "../../../../gateway/User/User";
import { ChatwootAdapter } from "../../../../presentation/adpters/ChatwootAdapter/ChatwootAdapter";
import { UserDataAdapter } from "../../../../presentation/adpters/UserDataAdapter";
import { Events } from "../../../../presentation/services/Events/Events";
import { OperationsStatus } from "../../../../presentation/services/OperationsStatus/OperationsStatus";
import {
    accountingUsers,
    accoutingTrialUsers,
    customerUsers
} from "../../../../utils/users-roles/users-roles";
export class AdminLayoutComponent {
    constructor(
        LayoutService,
        NavigationService,
        CentralSidenavService,
        UserProfileSidenavService,
        LoaderService,
        $transitions,
        $state,
        $rootScope,
        $stateParams,
        $scope,
        JWTService
    ) {
        this.LayoutService = LayoutService;
        this.NavigationService = NavigationService;
        this.CentralSidenavService = CentralSidenavService;
        this.UserProfileSidenavService = UserProfileSidenavService;
        this.LoaderService = LoaderService;
        this.$transitions = $transitions;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.$scope = $scope;
        this.JWTService = JWTService;

        this.User = new User();
        this.Insight = new Insight();
        this.Events = new Events();
        this.EadPlataformaService = new EadPlataformaService();
        this.OperationStatusDomain = new OperationStatus();
        this.OperationsStatus = new OperationsStatus({
            Scope: this.$scope,
            OperationStatusDomain: this.OperationStatusDomain,
            Insight: this.Insight
        });

        this.$rootScope.featureAvailable = {
            dashboard: true,
            parametrization: true,
            dre: true,
            vertical: true
        };
    }

    $onInit() {
        this.user = new UserDataAdapter().user();
        this.UserProfileSidenavService.setUser(this.user);
        this.CentralSidenavService.setUser(this.user);

        this.isCustomerUser = this.User.checkPermission({
            roles: _.get(this.user, "roles"),
            granted: customerUsers
        });

        this.isAccountingUser = this.User.checkPermission({
            roles: _.get(this.user, "roles"),
            granted: [...accountingUsers, ...accoutingTrialUsers]
        });

        this._initChat();

        this._initLayoutConfigs();
    }

    async onOpenWatchVideo() {
        const username = new UserDataAdapter().user()?.username;
        this.Events.send("menu.universidade.novocurso");
        const link = await this.EadPlataformaService.authentication(
            username,
            this.$state.params.accountingId
        );

        if (!link) {
            return this.alertEmail();
        }
        window.open(link, "_blank");
    }

    _initLayoutConfigs() {
        const layoutConfig = _.get(this.$state.current, "data.layoutConfig");

        this.LayoutService.setAppLayout(layoutConfig);

        this.$transitions.onStart({}, (transition) => {
            const layoutConfig = _.get(transition.to(), "data.layoutConfig");

            this.LayoutService.setAppLayout(layoutConfig);
        });

        //this.NavigationService.setValidationsContract();
    }

    afterOperationStatus = () => {
        this.$rootScope.$broadcast("ON_OPERATION_INSIGHT_GENERATOR");

        this.$rootScope.insightsGeneratorRunning = false;

        this.$rootScope.$broadcast(
            "SET_NANDA_NOTIFICATION",
            "INSIGHTS_GENERATOR_FINISH"
        );

        setTimeout(() => {
            this.$rootScope.$broadcast("SET_NANDA_NOTIFICATION", "CLEAR");
        }, 2500);
    };

    startOperationsStatusObservable() {
        this.$rootScope.insightsGeneratorRunning = true;

        this.OperationsStatus.setAccountingId(this.$state.params.accountingId);
        this.OperationsStatus.setCompanyId(this.$state.params.id);

        this.OperationsStatus.startOperationsStatusObservable(
            this.afterOperationStatus
        );
    }

    _initChat() {
        const chatwoot = new ChatwootAdapter();
        const sync = (stateName) => {
            try {
                chatwoot.syncRoute(stateName, new UserDataAdapter().user());
            } catch (err) {
                console.error("Chatwoot", err);
            }
        };
        sync(this.$state.current?.name);
        // O layout é recriado a cada troca de estado de topo; o `$transitions` é um só para o app,
        // e um hook registrado continua valendo também para as rotas sem este layout (login).
        if (ChatwootAdapter.observandoRotas) return;
        ChatwootAdapter.observandoRotas = true;
        this.$transitions.onSuccess({}, (transition) => sync(transition.to().name));
    }
}

AdminLayoutComponent.$inject = [
    "LayoutService",
    "NavigationService",
    "CentralSidenavService",
    "UserProfileSidenavService",
    "LoaderService",
    "$transitions",
    "$state",
    "$rootScope",
    "$stateParams",
    "$scope",
    "JWTService"
];

const name = "adminLayoutComponent";
const def = {
    controller: AdminLayoutComponent,
    bindings: {
        layoutConfig: "<"
    },
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
